export default __webpack_public_path__ + "static/media/claudia.55bfba07.png";